<template>
  <!--  多选题 -->
  <div :class="{'compact-mode': isCompactMode}">
    <div>
      <el-card class="box-card">
        <div slot="header" class="subjectTitle">
          <div class="subjectName">
            <span class="question-number">{{ subjectId }}.</span>
            <p v-html="processedTitle" class="editor-content-view question-title-content"></p>
          </div>
        </div>
        <div class="options-container">
          <el-checkbox-group ref="checkboxGroup" v-model="checkList" :disabled="isDis" class="custom-checkbox-group" :class="imageLayoutClass">
            <el-checkbox 
              :label="item.prefix" 
              v-for="(item,index) in questionBody.items" 
              :key="item.prefix"
              class="custom-checkbox-item"
              :class="{'user-selected-correct': haveAnswer && checkList.includes(item.prefix) && isUserChoiceCorrect(item.prefix),
                       'user-selected-wrong': haveAnswer && checkList.includes(item.prefix) && !isUserChoiceCorrect(item.prefix),
                       'image-option-item': allOptionsAreImages}">
              <div class="option-content">
                <span class="option-prefix">{{ item.prefix }}.</span>
                <div v-html="processContent(item.content)" class="editor-content-view option-text"></div>
              </div>
             
            </el-checkbox>
          </el-checkbox-group>
        </div>

        <div v-if="haveAnswer" class="answer-section">
          <!-- 答案信息区 -->
          <div class="answer-info">
            <!-- 第一行：标准答案 + 操作按钮 -->
            <div class="info-row standard-answer">
              <div class="row-left">
                <span class="label">标准答案</span>
                <span class="value answer-value">{{ questionBody.correct }}</span>
              </div>
              <div class="action-buttons">
                <!-- 解析补充功能暂时关闭 -->
                <span class="action-btn" @click="openAmendDialog()">
                  <i class="el-icon-warning-outline"></i> 纠错
                </span>
                <span class="action-btn" @click="collectQuestion()">
                  <i class="el-icon-star-off"></i> 收藏
                </span>
              </div>
            </div>
            
            <!-- 第二行：结果 + 难度 -->
            <div class="info-row two-col">
              <div class="info-item">
                <span class="label">结果</span>
                <el-tag size="small" v-if="questionBody.answerInfo.doRight" type="success" effect="light">
                  <i class="el-icon-check"></i> 正确
                </el-tag>
                <el-tag size="small" v-else type="danger" effect="light">
                  <i class="el-icon-close"></i> 错误
                </el-tag>
              </div>
              <div class="info-item">
                <span class="label">难度</span>
                <el-rate v-model="questionBody.difficult" disabled class="difficulty-rate"></el-rate>
              </div>
            </div>
            
            <!-- 第三行：得分 + 得分率 -->
            <div class="info-row two-col">
              <div class="info-item">
                <span class="label">得分</span>
                <span class="value">
                  <span class="score-current">{{ questionBody.answerInfo.score }}</span>
                  <span class="score-divider">/</span>
                  <span class="score-total">{{ questionBody.score }}</span>
                </span>
              </div>
              <div class="info-item">
                <span class="label">得分率</span>
                <span class="value score-rate" :class="{'rate-success': questionBody.answerInfo.score > 0}">
                  {{ parseInt(questionBody.answerInfo.score / questionBody.score * 100) }}%
                </span>
              </div>
            </div>
            
            <!-- 解析区 -->
            <div class="info-row analysis-row">
              <span class="label">解析</span>
              <div class="analysis-content" v-html="processedAnalyze"></div>
            </div>
          </div>
        </div>
      </el-card>
    </div>
    <amendDialog v-if="!isWrongBookPage" :amendDialogShow="amendDialogShow"
                 :questionId="this.questionBody.id"
                 @closeAmendDialog="closeAmendDialog">
    </amendDialog>

    <analysisDialog v-if="!isWrongBookPage" :analysisDialogShow="analysisDialogShow" :questionId="this.questionBody.id"
                    @closeAnalysisDialog="closeAnalysisDialog"></analysisDialog>
  </div>
</template>

<script>
import amendDialog from "@/components/amendDialog.vue"
import analysisDialog from "@/components/analysisDialog.vue"

export default {
  components: {
    analysisDialog,
    amendDialog
  },
  props: {
    subjectId: {
      type: Number,
      default: 1
    },
    isDis: {
      type: Boolean,
      default: false
    },
    questionBody: {
      type: Object,
      default: () => ({})
    },
    haveAnswer: {
      type: Boolean,
      default: false
    },
    chooseItem: {
      type: String,
      default: ""
    }
  },
  mounted() {
    // console.log(this.questionBody)
    if (this.haveAnswer) {
      // console.log(this.questionBody)
      this.checkList = this.questionBody.answerInfo.contentArray
    }
    // 检测图片选项布局
    this.$nextTick(() => {
      this.checkImageLayout();
    });
  },
  watch: {
    checkList: {
      handler: function (n, o) {
        if (this.haveAnswer) {

        } else {
          // console.log(this.checkList)
          if (this.checkList.length != 0) {
            // console.log(this.subjectId)
            // this.$emit("changed", {id:this.subjectId,name:this.checkList})
            this.$emit("changed", {
              id: this.subjectId,
              name: this.checkList,
              questionId: this.questionBody.id,
              content: "",
              contentArray: this.checkList,
              itemOrder: this.subjectId
            })
          } else {
            // console.log(this.subjectId)
            this.$emit("unchanged", {
              id: this.subjectId,
              name: this.checkList
            })
          }
        }

      },
      deep: true
    }
  },
  data() {
    return {
      checkList: [],
      columnsPerRow: 4, // 4: 四列, 2: 两列, 1: 一列
      amendDialogShow: false,
      analysisDialogShow: false
    }
  },
  methods: {
    // 处理内容中的图片 URL
    processContent(content) {
      return this.$processImages(content);
    },
    // 检测图片选项布局模式
    checkImageLayout() {
      if (!this.allOptionsAreImages) return;
      
      this.$nextTick(() => {
        const group = this.$refs.checkboxGroup?.$el;
        if (!group) return;
        
        const images = group.querySelectorAll('img');
        if (images.length === 0) return;
        
        // 计算每个选项的宽度（图片宽度 + 前缀宽度）
        let imageWidths = [];
        let loadedCount = 0;
        const gap = 15;
        const prefixWidth = 60; // 选项前缀宽度（包括复选框和字母）
        
        const checkAllLoaded = () => {
          loadedCount++;
          if (loadedCount === images.length) {
            images.forEach(img => {
              imageWidths.push((img.naturalWidth || img.width) + prefixWidth);
            });
            
            // 获取容器宽度，使用父元素的clientWidth更准确
            const container = group.closest('.el-card__body') || group.parentElement;
            const containerWidth = container?.clientWidth || group.parentElement?.clientWidth || 800;
            
            // 计算4个选项的总宽度
            const totalWidth4 = imageWidths.reduce((a, b) => a + b, 0) + (images.length - 1) * gap;
            
            // 计算每行2个时，最宽的一行的宽度
            const row1Width = (imageWidths[0] || 0) + (imageWidths[1] || 0) + gap;
            const row2Width = (imageWidths[2] || 0) + (imageWidths[3] || 0) + gap;
            const maxRowWidth2 = Math.max(row1Width, row2Width);
            
            // 计算单个最宽选项
            const maxSingleWidth = Math.max(...imageWidths);
            
            if (totalWidth4 <= containerWidth) {
              // 4个能放下，用四列
              this.columnsPerRow = 4;
            } else if (maxRowWidth2 <= containerWidth) {
              // 2个一行能放下，用两列
              this.columnsPerRow = 2;
            } else {
              // 只能每行1个
              this.columnsPerRow = 1;
            }
            
            // 二次检查：渲染后检测是否有截断
            this.$nextTick(() => {
              this.checkOverflow();
            });
          }
        };
        
        images.forEach(img => {
          if (img.complete) {
            checkAllLoaded();
          } else {
            img.onload = checkAllLoaded;
            img.onerror = checkAllLoaded;
          }
        });
      });
    },
    // 检测是否有内容被截断
    checkOverflow() {
      const group = this.$refs.checkboxGroup?.$el;
      if (!group) return;
      
      // 检查是否有横向溢出
      if (group.scrollWidth > group.clientWidth + 5) {
        // 有截断，降级布局
        if (this.columnsPerRow === 4) {
          this.columnsPerRow = 2;
          this.$nextTick(() => this.checkOverflow());
        } else if (this.columnsPerRow === 2) {
          this.columnsPerRow = 1;
        }
      }
    },
    // 判断用户选择的某个选项是否正确
    isUserChoiceCorrect(prefix) {
      // 获取正确答案数组
      const correctAnswers = this.questionBody.correct ? this.questionBody.correct.split(',') : [];
      // 判断该选项是否在正确答案中
      return correctAnswers.includes(prefix);
    },
    openAmendDialog() {
      // 如果在wrongBook页面，通过事件通知父组件
      if (this.isWrongBookPage) {
        this.$emit('openAmendDialog');
      } else {
        this.amendDialogShow = true;
      }
    },
    closeAmendDialog() {
      this.amendDialogShow = false;
    },
    openAnalysisDialog() {
      // 如果在wrongBook页面，通过事件通知父组件
      if (this.isWrongBookPage) {
        this.$emit('openAnalysisDialog');
      } else {
        this.analysisDialogShow = true;
      }
    },
    closeAnalysisDialog() {
      this.analysisDialogShow = false;
    },
    collectQuestion() {
      this.$message({
        type: 'success',
        message: '收藏成功！'
      });
    }
  },
  computed: {
    // 处理题目标题中的图片 URL
    processedTitle() {
      return this.$processImages(this.questionBody.title);
    },
    // 处理解析中的图片 URL
    processedAnalyze() {
      return this.$processImages(this.questionBody.analyze);
    },
    // 判断是否为紧凑模式（试卷页面）
    isCompactMode() {
      return this.$route.path === '/testPaperDetails';
    },
    // 判断是否在wrongBook页面
    isWrongBookPage() {
      return this.$route.path === '/wrongBook';
    },
    // 判断所有选项是否都是图片
    allOptionsAreImages() {
      if (!this.questionBody.items || this.questionBody.items.length === 0) {
        return false;
      }
      return this.questionBody.items.every(item => {
        if (!item.content) return false;
        // 检查内容是否只包含img标签（可能被p标签或其他标签包裹）
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = item.content;
        const images = tempDiv.querySelectorAll('img');
        const textContent = tempDiv.textContent.trim();
        // 如果有图片且没有其他文字内容，则认为是图片选项
        return images.length > 0 && textContent === '';
      });
    },
    // 图片选项布局类名
    imageLayoutClass() {
      if (!this.allOptionsAreImages) return {};
      return {
        'image-options-group': true,
        'four-per-row': this.columnsPerRow === 4,
        'two-per-row': this.columnsPerRow === 2,
        'one-per-row': this.columnsPerRow === 1
      };
    }
  }
}
</script>

<style lang="scss" scoped>

/* 紧凑模式下减少卡片左右间距（试卷页面） */
.compact-mode ::v-deep .el-card__header {
  padding-left: 0px;
  padding-right: 10px;
  border-bottom: none;
}

.compact-mode ::v-deep .el-card__body {
  padding-left: 0px;
  padding-right: 10px;
}

:deep(.editor-content-view pre) {
  word-wrap: normal;
  font-family: Consolas, Monaco, Andale Mono, Ubuntu Mono, monospace;
  background-color: #F5F2F0;
  /*border: 3px solid #ccc;*/
  border-radius: 5px;
  padding: 10px 10px;
  margin-top: 5px;
  /*margin-bottom: 10px;*/
  overflow-x: auto;
  font-size: 16px;
  line-height: 1.5;
  min-width: 750px;
  tab-size: 4;
}

:deep(.editor-content-view pre) {
  /*background-color: #eee;*/
  /*padding: 5px;*/
  /*border-radius: 3px;*/
}

/* 确保sub和sup标签被正确显示 */
::v-deep sub {
  vertical-align: sub;
  font-size: smaller;
}

::v-deep sup {
  vertical-align: super;
  font-size: smaller;
}

.subjectName {
  display: flex;
  align-items: flex-start;
  line-height: 1.6;

  .question-number {
    font-size: 18px;
    font-weight: 600;
    color: #303133;
    margin-right: 6px;
    flex-shrink: 0;
  }

  .question-title-content {
    font-size: 18px;
    color: #303133;
    line-height: 1.6;
    letter-spacing: 0.3px;
    margin: 0;
  }

  p {
    font-size: 18px;
  }
}

.options-container {
  margin-top: -28px;
  margin-bottom: 10px;
}

.option-content {
  display: flex;
  align-items: flex-start;
  flex: 1;
  min-width: 0;
  margin-top: 5px;
  line-height: 1.5;

  .option-prefix {
    font-size: 16px;
    color: #606266;
    font-weight: 500;
    margin-right: 6px;
    flex-shrink: 0;
  }

  .option-text {
    font-size: 16px;
    color: #303133;
    line-height: 1.5;
    margin: 0;
    flex: 1;
    min-width: 0;
    white-space: normal;
    word-break: break-all;
    overflow-wrap: anywhere;
  }
}


.answer-section {
  margin: 20px 0 10px 0;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e8e8e8;
}

.answer-info {
  padding: 12px 20px;
  background: #fafafa;
}

.info-row {
  display: flex;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px dashed #e8e8e8;

  &:last-child {
    border-bottom: none;
  }

  &.standard-answer {
    justify-content: space-between;
    
    .row-left {
      display: flex;
      align-items: center;
    }
    
    .label {
      min-width: 70px;
    }
    .answer-value {
      font-weight: 600;
      color: #409EFF;
      font-size: 16px;
    }
  }

  &.two-col {
    display: flex;
    gap: 60px;
  }
  
  &.analysis-row {
    align-items: flex-start;
    
    .label {
      min-width: 50px;
      padding-top: 2px;
    }
  }
}

.info-item {
  display: flex;
  align-items: center;
  min-width: 200px;
}

.label {
  font-size: 14px;
  color: #909399;
  margin-right: 12px;
  min-width: 50px;
}

.value {
  font-size: 14px;
  color: #333;
}

.score-current {
  font-weight: 600;
  color: #F56C6C;
  font-size: 16px;
}

.score-divider {
  margin: 0 4px;
  color: #c0c4cc;
}

.score-total {
  color: #909399;
}

.score-rate {
  font-weight: 600;
  color: #F56C6C;
  font-size: 16px;

  &.rate-success {
    color: #67C23A;
  }
}

.difficulty-rate {
  ::v-deep .el-rate__icon {
    font-size: 16px;
  }
}

/* 操作按钮 */
.action-buttons {
  display: flex;
  align-items: center;
  gap: 12px;
}

.action-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #409EFF;
  border: 1px solid #d9ecff;
  background: #ecf5ff;

  i {
    font-size: 13px;
  }

  &:hover {
    background: #409EFF;
    color: #ffffff;
    border-color: #409EFF;
  }
}

/* 解析内容 */
.analysis-content {
  flex: 1;
  font-size: 14px;
  line-height: 1.8;
  color: #606266;

  &:empty::before {
    content: '暂无解析';
    color: #c0c4cc;
  }
}

.content {
  margin-top: 20px;
  display: flex;

  span {
    color: #000;
    line-height: 20px;
  }
}

.custom-checkbox-group {
  display: flex;
  flex-direction: column;
}

.custom-checkbox-item {
  margin-top: 10px;
  display: flex;
  width: 100%;
  align-items: flex-start;
  padding: 6px 12px;
  border-radius: 6px;

  ::v-deep .el-checkbox__input {
    margin-top: 3px;
  }

  ::v-deep .el-checkbox__label {
    display: block;
    flex: 1;
    min-width: 0;
    white-space: normal;
    word-break: break-all;
    overflow-wrap: anywhere;
  }
}

::v-deep .option-text p,
::v-deep .option-text span,
::v-deep .option-text div {
  white-space: normal;
  word-break: break-all;
  overflow-wrap: anywhere;
}

::v-deep .option-text > *:first-child {
  margin-top: 0;
}

::v-deep .option-text > *:last-child {
  margin-bottom: 0;
}

/* 用户选中的行样式 */
.custom-checkbox-item.user-selected-correct {
  background-color: transparent;
}

.custom-checkbox-item.user-selected-wrong {
  background-color: transparent;
}

/* 用户选择标识样式 */
.user-choice-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  margin-left: auto;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 13px;
  white-space: nowrap;
  font-weight: 500;

  i {
    font-size: 13px;
    font-weight: bold;
  }
}

.choice-correct {
  background-color: #67C23A;
  color: #ffffff;
  border: none;
}

.choice-wrong {
  background-color: #F56C6C;
  color: #ffffff;
  border: none;
}

/* 图片选项的响应式布局 - 支持4列/2列/1列 */
.custom-checkbox-group.image-options-group {
  display: grid;
  gap: 15px;
  justify-content: start;
}

.custom-checkbox-group.image-options-group.four-per-row {
  grid-template-columns: repeat(4, auto); /* 4列模式 */
}

.custom-checkbox-group.image-options-group.two-per-row {
  grid-template-columns: 1fr 1.3fr; /* 2列模式，B/D稍向右 */
  gap: 15px 30px;
}

.custom-checkbox-group.image-options-group.one-per-row {
  grid-template-columns: auto; /* 1列模式 */
}

.custom-checkbox-item.image-option-item {
  width: auto; /* 让宽度由内容决定 */
  margin-right: 0;
}
</style>
